export enum PluginStatusEnum {
  NotConfigured = 'not_configured',
  NotEnabled = 'not_enabled',
  Enabled = 'enabled',
}
